import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Edit2, Check, X } from 'lucide-react';
import { ConfidenceIndicator } from './ConfidenceIndicator';

interface FieldEditorProps {
  field: string;
  value: string | number | null;
  confidence: number;
  onSave: (newValue: string) => void;
}

export function FieldEditor({ field, value, confidence, onSave }: FieldEditorProps) {
  const [isEditing, setIsEditing] = useState(false);
  const [editValue, setEditValue] = useState(String(value || ''));
  
  const handleSave = () => {
    onSave(editValue);
    setIsEditing(false);
  };
  
  const handleCancel = () => {
    setEditValue(String(value || ''));
    setIsEditing(false);
  };
  
  const needsReview = confidence < 0.5;
  
  return (
    <div className="flex items-center gap-2">
      <div className="flex-1">
        {isEditing ? (
          <Input
            value={editValue}
            onChange={(e) => setEditValue(e.target.value)}
            className="h-8"
            autoFocus
          />
        ) : (
          <div className={`px-2 py-1 rounded ${needsReview ? 'bg-red-50 text-red-900' : ''}`}>
            {value || '-'}
          </div>
        )}
      </div>
      
      <ConfidenceIndicator confidence={confidence} size="sm" />
      
      {isEditing ? (
        <div className="flex gap-1">
          <Button size="sm" variant="ghost" onClick={handleSave}>
            <Check className="h-3 w-3" />
          </Button>
          <Button size="sm" variant="ghost" onClick={handleCancel}>
            <X className="h-3 w-3" />
          </Button>
        </div>
      ) : (
        <Button size="sm" variant="ghost" onClick={() => setIsEditing(true)}>
          <Edit2 className="h-3 w-3" />
        </Button>
      )}
    </div>
  );
}
